import { useEffect, useState } from "react";
import useErrorHandler from "./FormErrorHandler";
import {
  TextInput,
  FormInputRow,
  FormSection,
  PhoneNumberInput,
  AddressInput,
  RadioInput,
  TextField,
} from "../FormInput/FormInput";

const PassengerInfo = ({
  id,
  index,
  data,
  updateInfo,
  canRemove = true,
}) => {
  const [isFocused, setIsFocused] = useState(false)
  const { error, addError, clearError, hasError, focusedField } = useErrorHandler();

  const validate = (formData) => {
    clearError();

    if (!formData.FirstName) {
      addError({ FirstName: "First name is required" }, false);
    }

    if (!formData.LastName) {
      addError({ LastName: "Last name is required" }, false);
    }

    if (formData.ZipCode && (isNaN(parseInt(formData.ZipCode)) || formData.ZipCode.toString().length != 5)){
      addError({ ZipCode: "Enter a 5 digit zip code" }, false);
    }

    if (!formData.Injured){
      addError({ Injured: "This field is required" }, false);
    }else if (formData.Injured == "Yes" && !formData.InjuryDescription){
      addError({ InjuryDescription: "This field is required" }, false)
    }

    return !hasError();
  };

  const [info, setInfo] = useState({ ...data, validate });

  const updateState = (fieldName, value) => {
    setInfo((prevInfo) => {
      const temp = { ...prevInfo, [fieldName]: value };
      updateInfo((prev) =>
        prev.map((person) =>
          person.id === prevInfo.id ? temp : person
        )
      );
      return temp;
    });
  };

  useEffect(() => {
    if(focusedField && isFocused){
      const fieldToFocus = index + focusedField
      const element = document.getElementById(fieldToFocus);
      if (element) {
        element.focus();
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [focusedField, isFocused, error])

  useEffect(() => {
    updateState("validate", validate);
    updateState("setIsFocused", setIsFocused);
  }, []);

  return (
    <FormSection
      header={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
          id={id}
        >
          <div>Passenger {index + 1}</div>
          {canRemove ? (
            <RemoveButton
              id={id}
              updateInfo={updateInfo}
            />
          ) : (
            <></>
          )}
        </div>
      }
    >
      <FormInputRow header="Full Name*">
        <TextInput
          id={index}
          fieldName="FirstName"
          value={info.FirstName}
          handleInputChange={updateState}
          placeholder="First Name"
          error={error}
        />
        <TextInput
          id={index}
          fieldName="LastName"
          value={info.LastName}
          handleInputChange={updateState}
          placeholder="Last Name"
          error={error}
        />
      </FormInputRow>

      <FormInputRow header="Phone Number">
        <PhoneNumberInput
          fieldName="PhoneNumber"
          value={info.PhoneNumber}
          handleInputChange={updateState}
          id={index}
          autoComplete="tel"
        />
      </FormInputRow>

      <FormInputRow header="Home Address">
        <AddressInput
          addressData={info}
          handleInputChange={updateState}
          error={error}
          id={index}
        />
      </FormInputRow>

      <FormInputRow header="Was this passenger injured?*">
          <RadioInput
            fieldName="Injured"
            value={info.Injured}
            handleInputChange={(fieldname, value) => 
              {
                updateState(fieldname, value)
                if(value == "No")
                  updateState("InjuryDescription", null)
              }
            }
            sameLine={true}
            error={error}
            options={[
              { label: "Yes", value: "Yes" },
              { label: "No", value: "No" },
            ]}
            id={index}
          />
        </FormInputRow>
        
        {info.Injured == "Yes" &&
          <FormInputRow header="Please describe any injuries this passenger sustained in the loss:*">
            <TextField
              id={index}
              fieldName="InjuryDescription"
              value={info.InjuryDescription}
              handleInputChange={updateState}
              error={error}
            />
          </FormInputRow>
        }
    </FormSection>
  );
};

const RemoveButton = ({ id, updateInfo }) => {
  const remove = () => {
    updateInfo((prev) =>
      prev.filter((person) => {
        return person.id !== id;
      })
    );
  };

  return (
    <button
      className="btn btn-primary btn-sm m-1 px-4 fw-bold"
      style={{ borderRadius: "20px" }}
      onClick={() => remove()}
    >
      Remove
    </button>
  );
};

export default PassengerInfo;
